import React from 'react'
import { Button, Modal, Input } from 'antd';
var languageFile = require('../../../../../public/languages/Translation');

export class AddPortFolioModal extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	render() {
		return (
			<>
				<Modal
					visible={this.props.showAddProtfolioOptions}
					title={languageFile[localStorage.getItem('language')]['28091']}
					width={450}
					onOk={this.props.handleOk}
					onCancel={this.props.handleCancel}
					footer={
						<div key="0">
							<Button
								key="cancel"
								// type="default"
								className='secondary-btn btn-padding-md'
								onClick={this.props.handleCancel}
							>
								{languageFile[localStorage.getItem('language')]['10523']}
							</Button>
							<Button
								className='primary-btn btn-padding-md'
								key="submit"
								// type="primary"
								loading={this.props.loading}
								onClick={this.props.addNewPortfolio}
							>
								{languageFile[localStorage.getItem('language')]["13723"]}
							</Button>
						</div>
					}
				>
					<div className="invite-options">
						<div className="hint-text">
							<span>
								{languageFile[localStorage.getItem('language')]['28101']}
							</span>
						</div>

						<div style={{ textAlign: 'center' }}>
							<Input
								placeholder={languageFile[localStorage.getItem('language')]['28111']}
								value={this.props.newPortfolio}
								onChange={this.props.newPortfolioChange}
								style={{ width: 180 }}
							/>
						</div>
						<div className="profile-name-error">
							{this.props.portfolioErrorMessage && (
								<span>{this.props.portfolioErrorMessage}</span>
							)}
						</div>
					</div>
				</Modal>
			</>
		)
	}
}

